// Rancho Los Amigos 8-phase gait-cycle model.
//
// We anchor phase boundaries on canonical cycle fractions (Perry). When a
// toe-off is available we scale the stance/swing split to the measured toe-off;
// otherwise the canonical ~62% boundary is used. This gives the clinically
// familiar phase structure without over-claiming sub-event precision.

export type Phase = "IC" | "LR" | "MSt" | "TSt" | "PSw" | "ISw" | "MSw" | "TSw";

export const PHASES: Phase[] = ["IC", "LR", "MSt", "TSt", "PSw", "ISw", "MSw", "TSw"];

export const PHASE_LABELS: Record<Phase, string> = {
  IC: "Initial contact",
  LR: "Loading response",
  MSt: "Mid stance",
  TSt: "Terminal stance",
  PSw: "Pre-swing",
  ISw: "Initial swing",
  MSw: "Mid swing",
  TSw: "Terminal swing",
};

// Canonical end-fractions of each phase within a gait cycle (toe-off ≈ 0.62).
const CANONICAL: Array<[Phase, number]> = [
  ["IC", 0.02],
  ["LR", 0.12],
  ["MSt", 0.31],
  ["TSt", 0.5],
  ["PSw", 0.62],
  ["ISw", 0.75],
  ["MSw", 0.87],
  ["TSw", 1.0],
];

/** Map a within-cycle fraction (0..1) to its Rancho phase. */
export function phaseOfFraction(frac: number, toeOffFrac = 0.62): Phase {
  // Rescale the canonical boundaries so the stance/swing split lands on the
  // measured toe-off fraction.
  const f = Math.min(1, Math.max(0, frac));
  for (const [phase, end] of CANONICAL) {
    const scaled =
      end <= 0.62 ? (end / 0.62) * toeOffFrac : toeOffFrac + ((end - 0.62) / 0.38) * (1 - toeOffFrac);
    if (f <= scaled) return phase;
  }
  return "TSw";
}
